<script setup lang="ts">

import { ref } from 'vue'

const props = defineProps(["text"])
const emit = defineEmits(["titleEdited"])

const isEditing = ref<boolean>(false)

const newTitle = ref<string>("")

const startEdit = () => {
    isEditing.value = true
    newTitle.value = props.text
}

const completeEdit = () => {
    isEditing.value = false
        if(newTitle.value.length > 3){
            emit("titleEdited", newTitle.value)
        }
}

const cancelEdit = () => {
    isEditing.value = false
}

</script>

<template>
    <div class="container">
        <h1 class="task-title" @dblclick="startEdit" v-if="!isEditing">
        {{ props.text }}
    </h1>
        <input v-else
        autofocus 
        @blur="completeEdit"
        @keyup.enter="$event.target?.blur()" 
        @keydown.esc="cancelEdit" 
        type="text" 
        v-model="newTitle">
            
    </div>

</template>

<style scoped>

.container{
    padding-top: 1.3rem;
}
h1.task-title,
input{
    font-size: 2.6rem;
    letter-spacing: 0.01px;
    color: var(--task-text-main);
    cursor: pointer;
}

input{
    outline: none;
    background-color: var(--box-color);
    user-select: none;
    width: 85%;
    border-radius: 1rem;
    padding-left: .5rem;
}


@media screen and (max-width: 850px){

    h1.task-title,
    input{
        font-size: 1.8rem;
    }
}

</style>